/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Issue_Wrong_FolderInputs */

const en_inbound_issue_wrong_folder = /** @type {(inputs: Inbound_Issue_Wrong_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the file was not uploaded for an inbound`)
};

/**
* | output |
* | --- |
* | "the file was not uploaded for an inbound" |
*
* @param {Inbound_Issue_Wrong_FolderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_issue_wrong_folder = /** @type {((inputs?: Inbound_Issue_Wrong_FolderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Issue_Wrong_FolderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_issue_wrong_folder(inputs)
});